

import { FaEye, FaEyeSlash } from "react-icons/fa";
import { GoogleAuthProvider } from 'firebase/auth';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '../../AuthProvider/Auth';
import './SIgnUp&SignIn.css'
import { RotatingLines } from 'react-loader-spinner';
import SocialMedia from '../../Assets/Social-media-facebook-like-vector-PNG.png'



const SignIn = () => {

  const { register, formState: { errors }, handleSubmit } = useForm();
  const provider = new GoogleAuthProvider();
  const { signIn, googleProvider } = useContext(AuthContext);
  const [loginError, setLoginError] = useState();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [loading2, setLoading2] = useState(false)



  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  const handleLogin = data => {
    setLoading(true)
    setLoginError('')

    signIn(data.email, data.password)
      .then(result => {
        const user = result.user;
        // console.log(user)
        navigate('/home', { replace: true });
        window.location.reload();
        setLoading(false)
        toast.success("Login Success");

      })
      .catch(err => {
        setLoginError(err.message);
        setLoading(false)
        toast.error("Something is wrong");
        // console.log(err.message);
      })
  }

  // handle google login 
  const googleSignIn = () => {

    setLoading2(true)
    googleProvider(provider)
      .then(result => {
        const user = result.user;
        console.log(user);
        const userData = {
          name: user?.displayName,
          email: user?.email,
        }

        fetch('https://e-somaz-server.vercel.app/users', {
          method: 'PUT',
          headers: {
            'content-type': 'application/json',
          },
          body: JSON.stringify(userData)
        })
          .then(res => res.json())
          .then(data => {
            console.log(data);
            if (data.acknowledged) {
              setLoading2(false)
              navigate('/home')
              toast.success(" Welcome to eConnect ");
            }
          })
      })
      .catch(err => {
        console.log(err.message);
        toast.error("Something is wrong try again");
        setLoading(false)
        setLoginError(err.message)
      })
  }




  return (


    <div className=" py-36 xl:py-40 2xl:py-60 transition-all duration-700 w-full md:w-[800px] lg:w-[900px] 2xl:w-[1200px] px-2 mx-auto flex-row-reverse md:flex">
      <div
        className="relative rounded-tr-2xl rounded-br-2xl  overflow-hidden md:flex w-1/2 bg-gradient-to-tr from-blue-500 to-blue-700  justify-around items-center hidden">
        <img src={SocialMedia} alt="img" />

      </div>
      <div className="flex w-full  px-5 md:px-10  rounded-2xl md:rounded-none md:rounded-tl-2xl md:rounded-bl-2xl md:w-1/2 justify-center py-10 items-center bg-white">
        <form onSubmit={handleSubmit(handleLogin)} className="bg-white w-full max-w-md">
          <h1 className="text-gray-800 font-bold text-2xl mb-1">Log In</h1>
          <p className="text-sm text-gray-600 font-semibold mb-7"> Your SocialMates are Await! </p>

          {/*  sign-in button */}
          {loading2 ? (
            <div className="flex gap-2 justify-center w-full cursor-not-allowed bg-blue-500 hover:bg-blue-700 transition-colors mt-4 py-2 rounded-2xl text-white font-semibold mb-2">
              Processing
              <RotatingLines
                strokeColor="white"
                strokeWidth="5"
                animationDuration="0.75"
                width="24"
                visible={true}
              />
            </div>
          ) : (
            <div onClick={googleSignIn} className="  w-full flex justify-center cursor-pointer bg-blue-500 hover:bg-blue-700 transition-colors mt-4 py-2 rounded-2xl text-white font-semibold mb-2">
              Continue with Google
            </div>
          )}

          {/* Divider */}
          <div className="divider w-50 m-auto mt-5 mb-5 text-gray-500 font-semibold"> Or sign In with e-mail</div>

          {/* Email input */}
          <div className="mb-4">
            <div className="flex items-center border-2 py-2 px-3 rounded-2xl">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
              </svg>
              <input
                {...register("email", {
                  required: "Email Address is required"
                })}
                className="pl-2 outline-none border-none flex-grow" // Use flex-grow for full width
                type="text"
                placeholder="Email Address"
              />
            </div>
            <span className="text-red-400"> {errors.email && <p role="alert">{errors.email?.message}</p>}</span>
          </div>

          {/* Password input with show/hide functionality */}
          <div className="mb-4">
            <div className="flex items-center border-2 py-2 px-3 rounded-2xl relative">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
              <input
                {...register("password", {
                  required: "Password is required",
                  pattern: { value: /(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])/, message: 'Password must be more strong' },
                  minLength: { value: 6, message: "Password must be 6 characters or longer" }
                })}
                className="pl-2 outline-none border-none flex-grow" // Use flex-grow for full width
                type={showPassword ? "text" : "password"}
                placeholder="Password"
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 focus:outline-none"
              >
                {showPassword ? <FaEye className="text-gray-500" /> : <FaEyeSlash className="text-gray-500" />}
              </button>
            </div>
            <span className="text-red-400"> {errors.password && <p role="alert">{errors.password?.message}</p>}</span>
          </div>

          {/* Submit button */}
          {loading ? (
            <button
              type="submit"
              className="flex gap-2 justify-center w-full bg-blue-500 hover:bg-blue-700 transition-colors mt-4 py-2 rounded-2xl text-white font-semibold mb-2"
            >
              Processing
              <RotatingLines
                strokeColor="white"
                strokeWidth="5"
                animationDuration="0.75"
                width="24"
                visible={true}
              />
            </button>
          ) : (
            <button
              type="submit"
              className="block w-full bg-blue-500 hover:bg-blue-700 transition-colors mt-4 py-2 rounded-2xl text-white font-semibold mb-2"
            >
              Log In
            </button>
          )}

          {/* Error message */}
          {loginError && <p className="text-center font-bold text-red-400">{loginError}</p>}

          {/* Sign up link */}
          <p className="text-sm mt-3 ml-2 font-semibold text-gray-600">
            Don't have an account? <span className="text-blue-700 font-extrabold"> <Link to={'/signUp'}>Sign Up</Link> </span>
          </p>
        </form>
      </div>
    </div>
  );
};

export default SignIn;